import axios from 'axios';
import authHeader from './auth-header';
import UserHelper from '../helpers/user.helper.js'

const API_URL = process.env.VUE_APP_API_URL + 'corridoring/';

class CorridoringService {

    getClientCorridorings(search = null) {
        return axios.get(API_URL + 'getclientcorridorings/' + UserHelper.getClientId(),
            {
                params: { search: search },
                headers: authHeader()
            });
    }

    getCorridoring(corridoringId) {
        return axios.get(API_URL + 'getcorridoring/' + corridoringId, { headers: authHeader() });
    }

    getCorridoringPositions(corridoringId) {
        return axios.get(API_URL + 'getcorridoringpositions/' + corridoringId, { headers: authHeader() });
    }

    createCorridoring(driveId, name) {
        return axios.put(API_URL + 'createclientcorridoring/' + UserHelper.getClientId(), {
            name: name,
            driveId: driveId
        },
            { headers: authHeader() });
    }

    deleteCorridoring(corridoringId) {
        return axios.delete(API_URL + 'delete/' + corridoringId, { headers: authHeader() });
    }

    updateCorridoring(cId, data) {
        return axios.put(API_URL + 'update/' + cId, data, { headers: authHeader() });
    }

    addBalise(cId, bId) {
        return axios.put(API_URL + 'addbalise/' + cId, { baliseId: bId }, { headers: authHeader() });
    }

    removeBaliseCorridoring(bId) {
        return axios.put(API_URL + 'removebalisecorridoring/' + bId, {}, { headers: authHeader() });
    }

    // Met à jour le radius d'une position
    updatePositionRadius(positionId, radius) {
        return axios.put(
            API_URL + 'position/' + positionId + '/radius',
            { radius },
            { headers: authHeader() }
        );
    }

    /**
     * Gère les geofencings du corridoring
     */
    getCorridoringFullData(corridoringId) {
        return axios.get(
            API_URL + corridoringId + '/full-data',
            { headers: authHeader() }
        );
    }

    addGeofencing(corridoringId, geofencingId) {
        return axios.put(
            API_URL + corridoringId + '/geofencing/' + geofencingId,
            {},
            { headers: authHeader() }
        );
    }

    removeGeofencing(corridoringId, geofencingId) {
        return axios.delete(
            API_URL + corridoringId + '/geofencing/' + geofencingId,
            { headers: authHeader() }
        );
    }

    /**
     * Crée un corridoring à partir d'une plage de dates (positions interval)
     * Body attendu côté API : { baliseId, from, to, name }
     */
    createCorridoringFromRange({ baliseId, from, to, name }) {
        return axios.put(
            API_URL + 'createfromrange/' + UserHelper.getClientId(),
            { baliseId, from, to, name },
            { headers: authHeader() }
        );
    }
}

export default new CorridoringService();